export default "__VITE_ASSET__B8ufBgP5__"